import { render, staticRenderFns } from "./ReviewFunnelPublic.vue?vue&type=template&id=6c97a260&scoped=true&"
import script from "./ReviewFunnelPublic.vue?vue&type=script&lang=js&"
export * from "./ReviewFunnelPublic.vue?vue&type=script&lang=js&"
import style0 from "./ReviewFunnelPublic.vue?vue&type=style&index=0&id=6c97a260&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c97a260",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRating } from 'vuetify/lib/components/VRating';
installComponents(component, {VIcon,VRating})
